import React from "react";

const NewProgressbar = ({ progress = 0 }) => {
    return (
        <div style={styles.container}>
            <div style={styles.track}>
                <div
                    style={{
                        ...styles.fill,
                        width: `${progress}%`,
                    }}
                />

                <div
                    style={{
                        ...styles.circle,
                        left: `calc(${progress}% - 21px)`, // center the circle
                    }}
                >
                    {progress}%
                </div>
            </div>
        </div>
    );
};

export default NewProgressbar;

const styles = {
    container: {
        background: "#e9f7f7",
        padding: "16px 0",
        borderRadius: "14px",
        width: "100%",
    },

    track: {
        position: "relative",
        height: "14px",
        background: "#ddd",
        borderRadius: "999px",
        overflow: "visible",
    },

    fill: {
        height: "100%",
        background: "#14b8a6",
        borderRadius: "999px",
        transition: "width 0.4s ease-in-out",
    },

    circle: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: "42px",
        height: "42px",
        borderRadius: "50%",
        background: "#14b8a6",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "600",
        fontSize: "14px",
        transition: "left 0.4s ease-in-out",
        pointerEvents: "none",
    },
};